export const isSomeOrElse = (elem: any, defaultValue: any) =>
  typeof elem === "undefined" || elem === null ? defaultValue : elem;

export const isNone = (elem: any) =>
  typeof elem === "undefined" || elem === null;

export const isSome = (elem: any) =>
  typeof elem !== "undefined" && elem !== null;
